import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h1" }

import { translation } from "../../../lang/Translation";

export default /*#__PURE__*/_defineComponent({
  __name: 'NoFilesInSection',
  setup(__props) {

const t = translation;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t).to("ファイルが存在しません. 🔍", "no_files")), 1))
}
}

})